import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import {
  currentUserSelector,
  openUsersListModalSelector,
  setOpenUsersListModal,
  setUsersListView,
  usersListViewSelector,
} from '../redux/slices/userSlice';

/**
 * Custom hook for managing the settings modal state and functionality.
 * @returns - the required properties and functions for the settings modal.
 */
const useUsersListModal = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const open = useAppSelector(openUsersListModalSelector);
  const currentUser = useAppSelector(currentUserSelector);
  const usersListView = useAppSelector(usersListViewSelector);
  const handleClose = () => dispatch(setOpenUsersListModal(false));
  useEffect(() => {}, [open, usersListView]);

  /**
   * Determines the view of the users list.
   * @param value - the value of the toggle button group.
   */
  const handleUsersListView = (value: 'followers' | 'following') => {
    dispatch(setUsersListView(value));
  };

  /**
   * Handles the user click event.
   * @param username - the username of the user to navigate to.
   */
  const handleUserClick = (username: string) => {
    handleClose();
    navigate(`/profile/${username}`);
  };

  return {
    open,
    handleClose,
    currentUser,
    handleUsersListView,
    usersListView,
    handleUserClick,
  };
};

export default useUsersListModal;
